@if(csp.userIsEnrolled() && bannerContent?.active){
    <section class="{{ isMobile ? 'mobileOnly' : 'desktop' }}" id="banner-section">
    <div class="banner" [ngClass]="{'justiy-content-center': !csp.isPlatformDesktop()}">
        <div class="left" [ngClass]="{'text-center': !csp.isPlatformDesktop()}">
            <h2 [innerHTML]="bannerContent?.header | safeHtml" class="text-white"></h2>
            <div [innerHTML]="bannerContent?.desc | safeHtml" class="text-white"></div>
        </div>
        @if(csp.isPlatformDesktop()){
            <div class="display-qr">
                <img [ngSrc]="csp.imagePrefix() + bannerContent?.QRImg?.src" [alt]="bannerContent?.QRImg?.adaText" height="87" width="87" />
            </div>
        }
    </div>
    
</section>
}
@else if(!csp.userIsEnrolled() && downloadSection?.active){

    <section class="desktop">
    <div class="backgroundImage" role="presentation" alt=""  [cache]="csp.imagePrefix() + downloadSection?.backgroundImagePath" 
    [lazyload]="csp.imagePrefix() + downloadSection?.backgroundImagePath">
        <div class="downloadText">
            <h2  [innerHTML]="downloadSection?.title"></h2>
            <app-citi-shop-add-to-browser-button
                *ngIf="csp.eanbleDownloadButton()"
                [sectionName]="downloadSection?.title"
                (buttonClicked)="buttonClicked($event)">
            </app-citi-shop-add-to-browser-button>
            <p *ngIf="!csp.eanbleDownloadButton()" class="displayMsg" [innerHTML]="downloadSection?.mobileText"></p>
        </div>
    </div>
</section>

<section class="mobileOnly">
    <div class="backgroundMob" role="presentation" alt=""  [cache]="csp.imagePrefix() + downloadSection?.mobileBackgroundImagePath" 
    [lazyload]="csp.imagePrefix() + downloadSection?.mobileBackgroundImagePath">
        <div class="downloadTextMob">
            <h2 [innerHTML]="downloadSection?.title"></h2>
            <p *ngIf="!csp.eanbleDownloadButton()" [innerHTML]="downloadSection?.mobileText"></p>
            <app-citi-shop-add-to-browser-button
                *ngIf="csp.eanbleDownloadButton()"
                [sectionName]="downloadSection?.title"
                (buttonClicked)="buttonClicked($event)">
            </app-citi-shop-add-to-browser-button>
        </div>
        <div>
            <img [cache]="csp.imagePrefix() + downloadSection?.mobileDownloadTodayImagePath" 
            [lazyload]="csp.imagePrefix() + downloadSection?.mobileDownloadTodayImagePath"
                        role="presentation" alt="">
        </div>
    </div>
</section>

}
